import type { FC } from 'react';
import { ConfirmationModal, ModalBody } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

import { useImageUploadContext } from '../ImageUploadContext';
import { ImageUploadModal } from '../ImageUploadService';

export const ImageLoadingModal: FC = () => {
    const { currentModal } = useImageUploadContext();

    if (currentModal !== ImageUploadModal.LoadingModal) {
        return null;
    }

    return (
        <ConfirmationModal isOpen title={t('app.loading')} isLoading>
            <ModalBody>{t('app.loading')}</ModalBody>
        </ConfirmationModal>
    );
};
